import { fetchCategoryProducts } from 'reducers/modules/mymigros/helpers';
import { MYMIGROS_SET_IS_FETCHING, MYMIGROS_SET_SLIDERS } from 'reducers/actions-types';

export default {
    /**
     * @param {IMyMigrosSlider} sliders
     * @param {string} apiEndpoint
     * @return {Promise<IProduct[]>}
     */
    fetchSliders(sliders, apiEndpoint) {
        return fetchCategoryProducts(sliders, apiEndpoint);
    },

    /**
     * Set sliders in the store
     * @param {IMyMigrosStateSliders} sliders
     */
    setSliders(sliders) {
        return function(dispatch) {
            dispatch({ type: MYMIGROS_SET_SLIDERS, sliders });
            dispatch({ type: MYMIGROS_SET_IS_FETCHING, isFetching: false });
        };
    },

};




// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/mymigros/actions.js